'use strict';

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.map");

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _emotion = require('emotion');

var _utils = require('../../../utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var highlightedStyling = /*#__PURE__*/(0, _emotion.css)('overflow:hidden;text-overflow:ellipsis;white-space:nowrap;.highlight{font-weight:600;padding:0;background-color:transparent;color:inherit;}');

var Highlight = function Highlight(props) {
  var textToHighlight = props.textToHighlight,
      searchWords = props.searchWords,
      autoEscape = props.autoEscape;
  var modSearchWords = searchWords.map(function (word) {
    return autoEscape ? (0, _utils.escapeRegExp)(word) : word;
  });
  var stringToReplace = modSearchWords.join('|');
  return _react2["default"].createElement('div', {
    className: highlightedStyling,
    dangerouslySetInnerHTML: {
      __html: textToHighlight.replace(new RegExp(stringToReplace, 'ig'), function (matched) {
        return '<mark class="highlight">' + matched + '</mark>';
      })
    }
  });
};

Highlight.propTypes = {
  searchWords: _propTypes2["default"].arrayOf(_propTypes2["default"].string),
  textToHighlight: _propTypes2["default"].string,
  autoEscape: _propTypes2["default"].bool
};
Highlight.defaultProps = {
  searchWords: [],
  textToHighlight: '',
  autoEscape: false
};
exports["default"] = Highlight;